"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var luxon_1 = require("luxon");
var normalizeServerDate_1 = require("../../utils/dates/normalizeServerDate");
function getCardExpiryDate(year, month) {
    if (!(year > 0 && month > 0))
        return null;
    return luxon_1.DateTime.utc(year, month).toFormat('yyyy-MM');
}
var statusNormalizer = function (response) {
    var order = response.data;
    var itemsPricePaid = 0;
    var itemsPrice = 0;
    var cart = Object.entries(order.cart).reduce(function (acc, _a) {
        var _b;
        var _c;
        var key = _a[0], cartItem = _a[1];
        itemsPricePaid += cartItem.price_paid;
        itemsPrice += cartItem.item_price * cartItem.quantity;
        var giftCardDetails = (_c = cartItem === null || cartItem === void 0 ? void 0 : cartItem.items) === null || _c === void 0 ? void 0 : _c.map(function (details) { return ({
            design: details.e_gift_card_details.card_design,
            recipientEmail: details.e_gift_card_details.gift_recipient_email,
            message: details.e_gift_card_details.gift_recipient_message,
            recipientName: details.e_gift_card_details.gift_recipient_name,
            senderName: details.e_gift_card_details.gift_sender_name,
            amount: details.price_paid,
        }); });
        return __assign(__assign({}, acc), (_b = {}, _b[key] = {
            quantity: cartItem.quantity,
            discount: cartItem.discount,
            itemPrice: cartItem.item_price,
            pricePaid: cartItem.price_paid,
            giftCardDetails: giftCardDetails,
            taxRate: cartItem.tax_rate,
            taxAmount: cartItem.tax_amount,
            includedVatAmount: cartItem.included_vat_amount,
            includedVatRate: cartItem.included_vat_rate,
        }, _b));
    }, {});
    var data = {
        orderId: order.order_number.toString(),
        isVerified: !!order.is_verified,
        securityCode: order.security_code,
        orderZip: order.order_zip,
        orderOutsideUsa: order.order_outside_usa,
        orderCountry: order.order_country,
        currency: order.order_currency,
        orderEmail: order.order_email,
        orderReferrer: order.order_referrer,
        orderReferral: order.order_referral,
        orderReferralCount: order.order_referral_count,
        orderValid: order.order_valid,
        trackingNumber: order.tracking_number,
        trackingUrl: order.tracking_url,
        createdOn: (0, normalizeServerDate_1.normalizeServerDate)(order.created_on),
        updatedOn: (0, normalizeServerDate_1.normalizeServerDate)(order.updated_on),
        cancelledOn: (0, normalizeServerDate_1.normalizeServerDate)(order.cancelled_on),
        rmaSentOn: (0, normalizeServerDate_1.normalizeServerDate)(order.rma_sent_on),
        cancelDeadline: (0, normalizeServerDate_1.normalizeServerDate)(order.cancel_deadline),
        processedShipmentOn: (0, normalizeServerDate_1.normalizeServerDate)(order.processed_shipment_on),
        shippedOn: (0, normalizeServerDate_1.normalizeServerDate)(order.shipped_on),
        deliveredOn: (0, normalizeServerDate_1.normalizeServerDate)(order.delivered_on),
        shipped: order.shipped,
        returned: order.returned,
        delivered: order.delivered,
        backordered: order.is_backordered,
        childOrderIds: order.child_order_ids,
        orderShippingCost: order.order_shipping_cost,
        orderPricePaid: order.order_price_paid,
        orderItemCost: order.order_item_cost,
        orderTaxPaid: order.order_tax_paid,
        orderTotalTaxPaid: order.order_total_tax_paid,
        orderDiscount: order.order_discount,
        orderStatus: order.order_state,
        osmoCredits: order.order_credits_users,
        referralDiscount: order.referral_discount,
        additionalDiscount: order.additional_discount,
        lastFour: order.last_four,
        paymentMethod: order.payment_method,
        cardExpiry: getCardExpiryDate(order.card_exp_year, order.card_exp_month),
        cardLabel: order.card_label,
        billing: {
            firstName: order.billing_first_name,
            lastName: order.billing_last_name,
            company: order.billing_company,
            address1: order.billing_address_1,
            address2: order.billing_address_2,
            address3: order.billing_address_3,
            city: order.billing_city,
            state: order.billing_state,
            country: order.billing_country || order.shipping_country || 'US',
            zip: order.billing_zip,
            phone: order.billing_phone,
            commercial: order.billing_commercial,
            opBox: order.billing_po_box,
            label: order.billing_address_label,
        },
        shipping: {
            firstName: order.shipping_first_name,
            lastName: order.shipping_last_name,
            company: order.shipping_company,
            address1: order.shipping_address_1,
            address2: order.shipping_address_2,
            address3: order.shipping_address_3,
            city: order.shipping_city,
            state: order.shipping_state,
            country: order.shipping_country,
            zip: order.shipping_zip,
            phone: order.shipping_phone,
            status: order.shipping_status,
            method: order.shipping_method,
            label: order.shipping_address_label,
        },
        checkout: order.checkout,
        expectedDeliveryDate: (0, normalizeServerDate_1.normalizeServerDate)(order.expected_delivery_date),
        expectedShippingDate: order.expected_shipping_date,
        includedVATAmount: order.included_vat_amount,
        includedVATRate: order.included_vat_rate,
        paymentFailed: order.payment_failed,
        paymentCaptured: order.payment_captured,
        tokenMethod: order.token_method,
        consentGiven: order.consent_given,
        websiteLanguage: order.website_language,
        referralUrl: order.referral_url,
        itemsPricePaid: itemsPricePaid,
        itemsPrice: itemsPrice,
        freeCreditsAmount: order.free_credits_amount,
        freeCreditsAwardedOn: (0, normalizeServerDate_1.normalizeServerDate)(order.free_credits_awarded_on),
        signInFreeCreditsAmount: order.sign_in_free_credits_amount,
        signInFreeCreditsAwardedOn: (0, normalizeServerDate_1.normalizeServerDate)(order.sign_in_free_credits_awarded_on),
        cart: cart,
        receiptItemizable: order.receipt_itemizable,
        serverHost: order.server_host,
        receiptUrl: order.receipt_url,
        requireShipment: order.require_shipment,
    };
    return __assign(__assign({}, response), { data: data });
};
exports.default = statusNormalizer;
